import React, { useMemo, useState } from 'react';
import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { CoTravelerSummary } from '@marageti/z4-sdk/lib/people';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import {
  formatTripDate,
  MAX_VISIBLE_CO_TRAVELERS,
  resolveCountries,
} from './utils';
import TravelWithSectionView from './travel-with-section-view';

type TravelWithSectionProps = {
  coTravelers?: CoTravelerSummary[] | null;
};

const TravelWithSection = ({ coTravelers }: TravelWithSectionProps) => {
  const apiClient = useApiClient();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: countryMap } = useFetchImmutable<CountryCodeMap>(
    apiClient.standardsClient.getCountryCodes,
    [],
    true,
  );

  const resolved = useMemo(
    () => (coTravelers ?? []).map((ct) => ({
      ...ct,
      trips: ct.trips.map((trip) => ({
        countries: resolveCountries(trip.countries, countryMap),
        tripDate: formatTripDate(trip.tripDate),
      })),
    })),
    [coTravelers, countryMap],
  );

  const visible = resolved.slice(0, MAX_VISIBLE_CO_TRAVELERS);
  const hiddenCount = resolved.length - visible.length;

  return (
    <TravelWithSectionView
      resolved={resolved}
      visible={visible}
      hiddenCount={hiddenCount}
      isModalOpen={isModalOpen}
      onOpenModal={() => setIsModalOpen(true)}
      onCloseModal={() => setIsModalOpen(false)}
    />
  );
};

export default TravelWithSection;
